import pick from 'lodash/pick';
import { ComponentType } from 'react';

export type FragmentInput = {
  /** Candidate props (fragment props + GrowthBook features); only the component's args pass. */
  props: Record<string, any>;
  /** Variants are passed as-is, after (and over) the picked props — same as before. */
  variants?: Record<string, any>;
};

/**
 * Wraps a lazily loaded Plasmic component so the allowed-props filter runs *inside* the lazy
 * chunk. The allowed list (`Plasmic<X>__ArgProps`) is a runtime array exported by the generated
 * module; reading it here — not in the registry — keeps that module out of every page's static
 * graph. Same output as the old `pick({ ...props, ...features }, propsAllowed)` + `...variants`.
 */
export function withAllowedProps(Component: ComponentType<any>, argProps: readonly string[], extra: readonly string[] = []) {
  const allowed = [...argProps, ...extra];
  const Picked = ({ fragmentInput, ...rest }: { fragmentInput: FragmentInput } & Record<string, any>) => (
    <Component {...rest} {...{ ...pick(fragmentInput.props, allowed), ...fragmentInput.variants }} />
  );
  return Picked;
}
